import React from "react";
import { AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

type Props = {
  backHandler?: any;
  text: string;
};

const TopBar = ({ text, backHandler }: Props) => {
  return (
    <AppBar position="sticky" sx={{ backgroundColor: "#0A0A0A", zIndex: 10 }}>
      <Toolbar
        sx={{
          minHeight: 48,
          px: 1,
          py: 1,
          width: "100%",
          justifyContent: !backHandler ? "center" : "start",
        }}
      >
        {backHandler && (
          <IconButton
            disableRipple
            onClick={backHandler}
            sx={{
              color: "white !important",
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography
          sx={{
            textAlign: "center",
            color: "white !important",
            fontSize: 22,
            fontFamily: "SF Pro",
            fontWeight: 600,
          }}
        >
          {text}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
